// extracted by mini-css-extract-plugin
export default {"container":"AllReports_container__vwzuc"};